/** @jsxImportSource @emotion/react */
import React, { useCallback } from "react";
import "./Banner.css";
import { useCookies } from "react-cookie";
import { css } from "@emotion/react";
import { buttonAsAnchorTag } from "../../config/commonCSS";
import { HostEnvironments } from "../../config/env";

const COOKIE_KEY = "showBanner";
const ONE_YEAR_MS = 31536000;

interface BannerProps {
  isVisible: boolean;
}

export const Banner: React.FC<BannerProps> = props => {
  const [cookies, setCookies] = useCookies();
  const handleDismiss = useCallback(() => {
    setCookies(COOKIE_KEY, ONE_YEAR_MS);
  }, [setCookies]);

  if (!props.isVisible || cookies[COOKIE_KEY]) {
    return null;
  }

  const BANNER_STYLES_BY_ENV: Record<string, string> = {
    [HostEnvironments.BETA]: "#E9BA04",
  };

  const bannerText = () => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      return (
        <>
          You are currently trading on a beta version of Bebop. Try{" "}
          <a
            href="https://docs.bebop.xyz/beta/bebop-ui/whats-new"
            target="_blank"
            rel="nofollow noreferrer"
          >
            what’s new
          </a>{" "}
          or click{" "}
          <a href="https://bebop.xyz/trade" rel="nofollow noreferrer" target="_blank">
            here
          </a>{" "}
          to go back.
        </>
      );
    }
    return (
      <>
        You are currently trading on a beta version of Bebop. Try{" "}
        <a
          href="https://docs.bebop.xyz/beta/bebop-ui/whats-new"
          target="_blank"
          rel="nofollow noreferrer"
        >
          what’s new
        </a>{" "}
        and{" "}
        <button className="open-intercom" css={css(buttonAsAnchorTag)}>
          share your feedback
        </button>
        . You can also click{" "}
        <a href="https://bebop.xyz/trade" rel="nofollow noreferrer" target="_blank">
          here
        </a>{" "}
        to go back.
      </>
    );
  };

  return (
    <div className="banner" style={{ background: BANNER_STYLES_BY_ENV[HostEnvironments.BETA] }}>
      <p className="text-center m-0">{bannerText()}</p>
      <button
        type="button"
        className="btn-secondary-close banner-close"
        onClick={() => handleDismiss()}
        aria-label="Close"
      />
    </div>
  );
};
